<template>
  <div class="sp-company-info">
    <avatar-upload class="avatar" :file-url="avatarUrl"  @changed='avatarChanged'/>
    <main-info-form
      :value="spCompanyRegistrationMainInfo"
      :regions="regions"
      :amountOfEmployees="amountOfEmployees"
      :companySuggestions="companySuggestionsForSP"
      :companySuggestionsLoading="registrationCompanySuggestionsLoading"
      @changed="formChanged"
      @companySuggest="suggestCompany"

    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MainInfoForm from '@/components/spCompanyRegistration/MainInfoForm.vue';
import {
  CHANGE_SP_COMPANY_AVATAR,
  CHANGE_SP_COMPANY_MAIN_INFO,
  LOAD_COMPANY_SUGGESTIONS_FOR_SP,
} from '@/store/spCompanyRegistration/actionTypes';
import AvatarUpload from '@/components/common/AvatarUpload.vue';

export default {
  name: 'SPCompanyInfo',
  components: {
    MainInfoForm,
    AvatarUpload,
  },
  data() {
    return {
      recaptchaUserToken: null,
      avatarUrl: null,
    };
  },
  computed: {
    ...mapGetters([
      'spCompanyLoading',
      'spCompanyLoadingErrors',
      'companySuggestionsForSP',
      'spCompanyRegistrationMainInfo',
      'spCompanyAmountOfEmployees',
      'spCompanyRegions',
    ]),
    regions() {
      return this.spCompanyRegions.map(region => ({ text: this.$t(`${region}`), id: region }));
    },
    amountOfEmployees() {
      return this.spCompanyAmountOfEmployees.map(amount => ({
        text: this.$pt('registration.workspace.info.amount.of.employees', amount),
        amount,
      }));
    },
    registrationCompanySuggestionsLoading() {
      return this.spCompanyLoading.companySuggestionsForSP || false;
    },
  },
  async mounted() {
    await this.$recaptchaLoaded();
    this.$recaptchaInstance.showBadge();
  },
  beforeDestroy() {
    this.$recaptchaInstance.hideBadge();
  },
  methods: {
    formChanged(value) {
      this.$store.dispatch(CHANGE_SP_COMPANY_MAIN_INFO, value);
    },
    suggestCompany(value) {
      if (value) {
        this.$store.dispatch(LOAD_COMPANY_SUGGESTIONS_FOR_SP, value);
      }
    },
    avatarChanged(file) {
      this.avatarUrl = file;
      this.$store.dispatch(CHANGE_SP_COMPANY_AVATAR, file);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.avatar {
  flex: 0.75;
  margin-right: 7%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sp-company-info {
  display: flex;
  flex: 0.7;
  margin: 0 0;

  padding-top: rem(40);
  padding-bottom: rem(40);

  padding-left: rem(118);
  padding-right: rem(152);

  border-radius: $radius-sm;
  background-color: $white;
  box-shadow: 0 0 rem(4) 0 rgba(14, 31, 51, 0.13);

  .client-info-form {
    flex: 1;
  }
}
</style>
